<script lang="ts" setup>
import Swal from 'sweetalert2';
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  width: {
    type: String,
    default: '550px',
  },
  title: {
    type: String,
    default: '',
  },
  height: {
    type: String,
    default: 'fit-content',
  },
});
const emit = defineEmits(['update:modelValue']);
const close = () => {
  if (!Swal.isVisible()) emit('update:modelValue', false);
};
</script>
<template>
  <v-dialog
    :width="props.width"
    v-model="props.modelValue"
    @update:modelValue="emit('update:modelValue', $event)"
    class="default-popup"
    persistent
  >
    <div class="default-popup__wrap">
      <div class="default-popup__header">
        <p class="default-popup__title">
          {{ title }}
        </p>
        <v-btn
          type="button"
          icon
          width="40px"
          height="40px"
          class="px-10"
          @click="close"
          style="max-width: 40px !important; min-width: 40px !important"
        >
          <v-icon size="20px">custom:close</v-icon>
        </v-btn>
      </div>
      <div
        class="default-popup__content"
        :style="{ height: `${props.height}`, maxHeight: `${props.height}` }"
      >
        <slot></slot>
      </div>
      <div class="default-popup__actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </v-dialog>
</template>
<style lang="scss">
.default-popup {
  // 최대 높이 기본값 무시
  .v-overlay__content[style*='max-height: fit-content'] {
    .default-popup__content {
      max-height: fit-content;
    }
  }
  &__wrap {
    border-radius: 16px;
    background-color: $white;
    padding-block-end: 24px;
  }

  &__header {
    display: flex;
    column-gap: 10px;
    align-items: center;
    padding-inline: 24px 10px;
    height: 73px;
  }
  &__title {
    flex: auto;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 140%;
  }
  &__content {
    padding-inline: 24px;
    padding-bottom: 10px;
    overflow-y: auto;
  }
  &__actions {
    display: flex;
    column-gap: 12px;
    justify-content: center;
    padding-top: 24px;
    > .v-btn {
      min-width: 90px;
    }
  }
  .gg-notice-box {
    margin-inline: -24px;
  }
}
</style>
